import React, { useState } from 'react';
import { Button, Drawer, Tag } from 'antd';
import { EditFilled, DeleteFilled, CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import EditCampaign from "./EditCampaign";
import DeleteCampaign from "./DeleteCampaign";

export default function ShowCampaignTable({ data, setRefreshSearch }) {
    const [visibleEdit, setVisibleEdit] = useState(false);
    const [visibleRemove, setVisibleRemove] = useState(false);

    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

    const handleEdit = (item) => {
        console.log("[handleEdit]:item=", item);
        setSelectedItem(item);
        setVisibleEdit(true);
    };

    const handleRemove = (item) => {
        console.log("[handleRemove]:item=", item);
        setVisibleRemove(true);
        setSelectedDeleteItem(item);
    };

    const onCloseEdit = () => {
        console.log("[onCloseEdit]");
        setSelectedItem(null);
        setVisibleEdit(false);
    };

    const onCloseRemove = () => {
        setVisibleRemove(false);
        setSelectedDeleteItem(null);
    };

    return (
        <>
            <Drawer title="Edit Campaign" placement="right" onClose={onCloseEdit} visible={visibleEdit} width={450}>
                {selectedItem && (
                    <EditCampaign
                        item={selectedItem}
                        setRefreshSearch={setRefreshSearch}
                        setVisibleEdit={setVisibleEdit}
                        setSelectedItem={setSelectedItem}
                    />
                )}
            </Drawer>

            <Drawer title="Remove Campaign" placement="right" onClose={onCloseRemove} visible={visibleRemove} width={450}>
                {selectedDeleteItem && (
                    <DeleteCampaign
                        item={selectedDeleteItem}
                        setRefreshSearch={setRefreshSearch}
                        setVisibleRemove={setVisibleRemove}
                    />
                )}
            </Drawer>

            <table className='table1'>
                <thead>
                    <tr>
                        <th width="150px">Company</th>
                        <th width="200px">Campaign Name</th>
                        <th width="100px">Year</th>
                        <th width="150px">Hotline</th>
                        <th>Note</th>
                        <th width="130px">Status</th>
                        <th width="180px">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map(item => (
                        <tr key={item.id}>
                            <td>{item.company_name}</td>
                            <td>{item.name}</td>
                            <td>{item.year}</td>
                            <td>{item.hotline}</td>
                            <td>{item.note || "-"}</td>
                            <td>
                                {item.activestatus === 1 ? (
                                    <Tag icon={<CheckCircleFilled />} color="success">Active</Tag>
                                ) : (
                                    <Tag icon={<CloseCircleFilled />} color="default">Deactivate</Tag>
                                )}
                            </td>
                            <td>
                                <div className='rowFlex'>
                                    <Button onClick={() => handleEdit(item)} icon={<EditFilled style={{ color: 'hotpink' }} />}>Edit</Button>
                                    <Button onClick={() => handleRemove(item)}><DeleteFilled style={{ color: 'red' }} />Remove</Button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
}
